var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dz-head-tabs" },
    [
      _c(
        "el-tabs",
        {
          staticClass: "dz-tab",
          attrs: { "before-leave": _vm.beforeLeave },
          on: { "tab-click": _vm.tabClick },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _vm._l(_vm.tabs, function (tab, index) {
            return _c("el-tab-pane", { key: index, attrs: { name: tab.tab } }, [
              _c(
                "span",
                {
                  staticClass: "tab-item",
                  attrs: { slot: "label" },
                  slot: "label",
                },
                [
                  tab.icon ? _c("i", { class: tab.icon }) : _vm._e(),
                  tab.img
                    ? _c("img", { attrs: { src: tab.img, alt: "" } })
                    : _vm._e(),
                  _vm._v(" " + _vm._s(tab.name) + " "),
                  tab.badge
                    ? _c("badge", { attrs: { txt: tab.badge } })
                    : _vm._e(),
                  tab.explanation
                    ? _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            content: tab.explanation,
                            placement: "top",
                            "open-delay": 500,
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "iconfont-npm icon-npm-yiwen",
                          }),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ])
          }),
          _vm._t("default"),
        ],
        2
      ),
      _vm._t("moreCourse"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }